const state = {
  loading: false
}

const mutations = {
  setStartLoading (state) {
    state.loading = true
  },
  setFinishLoading (state) {
    state.loading = false
  }
}

const getters = {
  loading: state => {
    return state.loading
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/modals.js